
import { Component, OnInit, Input } from '@angular/core';
import { RxPopup } from '@rx/view';
import { CallDbService } from '../call-db.service';

@Component({
    templateUrl: './call-db-access-log.component.html'
})

export class CallDbAccessLogComponent implements OnInit {
    @Input() recordId: number;

    showComponent = false;

    accessLogs = [];

    constructor(private popup: RxPopup,

     private callDbService: CallDbService) { }

   ngOnInit() {
    this.callDbService
        .getAccessLog(this.recordId)
        .subscribe(result => {
            this.accessLogs = result;
        });
         this.showComponent = true;
        }

        HidePopup() {
            document.body.className = "";
            this.popup.hide(CallDbAccessLogComponent);
        }

    }